import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from '@/app/App';
import '@/styles/app.css';
import { adoptBootClock } from '@/lib/loader-clock';

/* Before anything renders: the splash in index.html is already looping. React's loaders join it. */
adoptBootClock();

const root = document.getElementById('root');
if (!root) throw new Error('#root not found');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
